import React from "react";
import { NavbarCMS, TableAboutMission } from "../../components";
import { useSelector } from "react-redux";

const MissionCMS = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.about_missions?.navbar} />
            <TableAboutMission />
        </div>
    )
}

export default MissionCMS;